import { render, staticRenderFns } from "./AppointmentCancel.vue?vue&type=template&id=237972e9&scoped=true&lang=pug"
import script from "./AppointmentCancel.vue?vue&type=script&lang=js"
export * from "./AppointmentCancel.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCancel.vue?vue&type=style&index=0&id=237972e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237972e9",
  null
  
)

export default component.exports